import styled from 'styled-components';

const Title = styled.span`
  ${({ theme }) => theme.fontFamily.mainFont.mediumExtraBold}
  min-height: 20px;
  display: block;
  margin-left: ${({ theme }) => theme.constants.lateralSpace};
`;

export default Title;
